// extracted by mini-css-extract-plugin
export default {"tablebody":"TableBody_tablebody__Ppayd"};